/**
 * @generated SignedSource<<bf4993e4ca90397198e264a19dacd772>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeepArState = "COMPLETED" | "ERROR" | "PROCESSING" | "WAITING";
export type DeepArTaskInput = {
  id?: string | null;
  settings: DeepArSettingInput;
  state: DeepArState;
  url: string;
};
export type DeepArSettingInput = {
  environment: string;
  position: CoordinatesInput;
  rotation: CoordinatesInput;
  scale: number;
};
export type CoordinatesInput = {
  x: number;
  y: number;
  z: number;
};
export type deepARUpdateOrCreateMutation$variables = {
  input: DeepArTaskInput;
};
export type deepARUpdateOrCreateMutation$data = {
  readonly updateOrCreateDeepArTask: {
    readonly deepArTask: {
      readonly id: string;
      readonly settings: {
        readonly environment: string;
        readonly position: {
          readonly x: number;
          readonly y: number;
          readonly z: number;
        };
        readonly rotation: {
          readonly x: number;
          readonly y: number;
          readonly z: number;
        };
        readonly scale: number;
      };
      readonly state: DeepArState;
      readonly url: string;
    } | null;
  };
};
export type deepARUpdateOrCreateMutation = {
  response: deepARUpdateOrCreateMutation$data;
  variables: deepARUpdateOrCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "x",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "y",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "z",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeepArTaskOutput",
    "kind": "LinkedField",
    "name": "updateOrCreateDeepArTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DeepArTask",
        "kind": "LinkedField",
        "name": "deepArTask",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DeepArSetting",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Coordinates",
                "kind": "LinkedField",
                "name": "position",
                "plural": false,
                "selections": (v1/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Coordinates",
                "kind": "LinkedField",
                "name": "rotation",
                "plural": false,
                "selections": (v1/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "scale",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "environment",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deepARUpdateOrCreateMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deepARUpdateOrCreateMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "2ec00e7fb3c9b65117e36dabe00d36b1",
    "id": null,
    "metadata": {},
    "name": "deepARUpdateOrCreateMutation",
    "operationKind": "mutation",
    "text": "mutation deepARUpdateOrCreateMutation(\n  $input: DeepArTaskInput!\n) {\n  updateOrCreateDeepArTask(input: $input) {\n    deepArTask {\n      id\n      url\n      state\n      settings {\n        position {\n          x\n          y\n          z\n        }\n        rotation {\n          x\n          y\n          z\n        }\n        scale\n        environment\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c8e27aaf5ef85f33310580b43310f98f";

export default node;
